import React, { Suspense } from 'react';

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import { routes } from './router-data';
import Area from '../../pages/Area/Area';
import Registration from '../../pages/Registration/Registration';
import PasswordReset from '@features/password-reset';
import EmailConfirm from '@features/email-confirm';
import Login from '../../pages/Login/Login';
import NotFound from '../../pages/NotFound/NotFound';
import RequestAccess from '@features/request-access';
import OpenRegistration from '@features/open-registration';
export const Router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<Area />}>
        {routes.map((r, i) => (
          <Route
            loader={r.loader as any}
            key={i}
            path={r.path}
            element={<Suspense>{r.element}</Suspense>}
          >
            {r.children?.map((child: any, ci: number) => (
              <Route
                key={ci}
                index={child.index}
                path={child.index ? undefined : child.path}
                element={<Suspense>{child.element}</Suspense>}
              />
            ))}
          </Route>
        ))}
      </Route>
      <Route element={<Login />} path="/login" />
      <Route element={<Registration />} path="/registration/:id" />
      <Route element={<OpenRegistration />} path="/register" />
      <Route element={<PasswordReset />} path="/password_reset/:key" />
      <Route element={<EmailConfirm />} path="/email_confirm/:code" />
      <Route element={<RequestAccess />} path="/request_access" />
      <Route path="*" element={<NotFound />} />
    </Route>
  )
);
